import { useContext } from "react"
import { ToolContext } from "../../../../core/context/ToolContext"
import { List } from "./list/Index"
import { Setup } from "./setup/Index"

export const Product = ({match}) => {
    const { setup_state, tool_state } = useContext(ToolContext)
    const { productList, snackBarLoader } = setup_state
    const { __SESSION } = tool_state
    let loc = match.params.params
    if (loc === 'list') {
        return <List loader={snackBarLoader.data} setLoader={snackBarLoader.set} __SESSION={__SESSION}/>
    }else{
        return (
            <>
            <Setup loc={loc} productList={productList} loader={snackBarLoader.data} setLoader={snackBarLoader.set} __SESSION={__SESSION}/>
            </>
        )
    }
}